import React, { Component } from 'react'
import { kegSizes } from '../config'
import MainDrawer from '../InternalNavigation/drawer';
import InternalNavigation from '../InternalNavigation';
import { selectors, actions } from '../sagas/products/update';
import { selectors as productShowSelectors } from '../sagas/products/show';
import { selectors as session_selectors } from '../sagas/session'
import { selectors as kegSizeSelectors } from '../sagas/keg_sizes'
import { actions as inventoryActions } from '../sagas/inventory'
import { actions as productShowActions } from '../sagas/products/show';
import { actions as kegSizeActions } from '../sagas/keg_sizes'
import '../stylesheets/update_product.sass'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextInput } from '../shared/TextInput'
import S3Uploader from '../shared/ImageUpload'
import { FormError } from '../shared/FormError'
import Price from './price'
import { Image } from './image'
import _ from 'lodash'

const appendQuantityToAlwaysOn = (values) => {
  let alwaysOn = {}
  values && Object.keys(values).forEach(key => {
    alwaysOn[`${key}Quantity`] = values[key]
  })
  return alwaysOn
}


class UpdateProduct extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      drawer: false,
      imageUploader: false,
      showImageUpload: false
    };

    this.updateProduct = this.props.actions.update_actions.updateProduct.bind(this)
    this.setImageUrl = this.props.actions.update_actions.setImageUrl.bind(this)
    this.showProduct = this.props.actions.product_show_actions.showProduct.bind(this)
    this.props.actions.keg_size_actions.getKegSizes()
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  toggleImage = () => {
    this.setState({ showImageUpload: !this.state.showImageUpload })
  }

  handleCustomSubmit = () => {
    let id = this.props.product && this.props.product.id
    this.updateProduct(id)
  }

  componentWillMount () {
    let product = this.getProduct()
    this.showProduct(product && product['id'])

    let imageUrl = product && product['imageUrl']
    if (imageUrl === undefined) {
      this.toggleImage()
    }
    this.props.actions.inventory_actions.getInventory()
    product && this.props.initialize({...product, ...product['prices'], ...appendQuantityToAlwaysOn(product['alwaysOnQuantity'])})
  }

  componentWillUnmount () {
    this.props.actions.update_actions.clearErrors()
  }

  getProduct() {
    return this.props.location
      && this.props.location['state']
      && this.props.location['state']['product']
      && this.props.location['state']['product']['attributes']
  }

  render() {
    let product = this.props.product
    const { handleSubmit } = this.props

    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className={'product-page-wrapper'}>
          { this.props.errors && Object.keys(this.props.errors).length > 0 && <FormError errors={this.props.errors}/> }
          { product &&
            <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
              <div style={{ 'marginBottom': 30 }} className={'page-title'}>
                Update Product
              </div>
              <div className={'product-details'}>
                <div>
                  <TextInput
                    placeholderText={'Product Name'}
                    inputName={'name'}
                    label={'Product Name'}
                  />
                  <TextInput
                    placeholderText={'Description'}
                    inputName={'description'}
                    label={'Description'}
                    textarea
                    rows={3}
                    extraClass={'description-text-area'}
                  />
                </div>
                <div className='product-image-wrapper'>
                  <label>
                    Product Photo
                  </label>
                 { !this.state.showImageUpload &&
                   product.attributes &&
                   product.attributes.imageUrl &&
                  <Image
                    image_url={product['attributes']['imageUrl']}
                    imageClass='product-update-image'
                    height='215'
                    width='215'
                  />
                 }
                 { this.state.showImageUpload &&
                  <div className={'product-upload-card'}>
                    <S3Uploader
                      token={this.props.token}
                      type={'product'}
                      path={'product'}
                      finished={this.setImageUrl}
                    />
                  </div>
                  }
                  <div onClick={ this.toggleImage }>
                    Upload New Image
                  </div>
                </div>
              </div>
              <div className={'page-title'} style={{ 'marginTop': 30, 'marginBottom' : 30 }}>
                Inventory
              </div>
              { this.props.kegSizes.map(kegSize => {
                return (
                  <Price
                    key={ kegSize['size'] }
                    input={ _.camelCase(kegSize['size']) }
                    size={ kegSize }
                    product={ product }
                    showProduct = { this.showProduct }
                  />
                 )
               })
             }
              <input
                style={{ 'cursor': 'pointer', 'backgroundColor': this.props.loading ? 'grey' : 'black' }}
                disabled={ this.props.loading }
                value="Update"
                type="submit"
                id='continue-button' />
            </form>
          }
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => ({
  token: session_selectors.token(store),
  errors: selectors.errors(store),
  kegSizes: kegSizeSelectors.kegSizes(store),
  product: productShowSelectors.product(store),
  loading: selectors.loading(store)
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      update_actions: bindActionCreators(actions, dispatch),
      inventory_actions: bindActionCreators(inventoryActions, dispatch),
      keg_size_actions: bindActionCreators(kegSizeActions, dispatch),
      product_show_actions: bindActionCreators(productShowActions, dispatch)
    }
  }
}

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  { form: 'update_product'}
)(UpdateProduct)));



// WEBPACK FOOTER //
// ./src/Products/update.jsx